import styled, { css } from "styled-components";
import { borderRadius, color, typeStyle, units } from "@m/alchemy-theme";
import { StyledHTML } from "../../styled-html/index";
import { inputStateCSS } from "../input/Input.styled";
export const SlateRTE = styled.div `
  position: relative;
  ${typeStyle("bodyS")};
  color: ${color("typeBody")};
  ${(props) => inputStateCSS({ ...props, backgroundColor: color("container") })};
  border-radius: ${borderRadius("extraExtraLarge")};
  overflow: hidden;
`;
export const EditorWrapper = styled(StyledHTML) `
  position: relative;
  border-top: 1px solid ${color("lineContrast")};
  overflow-x: hidden;
  min-height: ${({ minHeight }) => minHeight ?? "auto"};
  max-height: ${({ maxHeight }) => maxHeight ?? "80vh"};

  ${({ shouldCollapseLastMargin }) => shouldCollapseLastMargin &&
    css `
      & > * > *:last-child {
        margin-bottom: 0 !important;

        & > *:last-child {
          margin-bottom: 0 !important;
        }
      }
    `}
`;
export const CharacterCountWrapper = styled.footer `
  text-align: right;
  padding: ${units(0.5)} ${units(2)} ${units(1)};
  ${typeStyle("captionM")}
  color: ${({ isValid }) => isValid ? color("base", { palette: "expressiveNeutral" }) : color("base", { palette: "expressiveNegative" })};
  border-bottom-left-radius: inherit;
  border-bottom-right-radius: inherit;
`;
export const Placeholder = styled.span `
  color: ${color("typeMeta")};
  font-style: italic;
  pointer-events: none;
  user-select: none;
  position: absolute;
  display: block;
  max-width: 100%;
  width: 100%;
`;
